import {AUTO_SELECTION_CAMERA_CENTRAL_ZONE_FRACTION} from '../../configs/autoSelectionCamera';

/**
 * Куда поставить центр свободной области, когда автовыбор выбрал отряд (change
 * unit-auto-selection). Свободная область по каждой оси делится на четыре
 * части, две средние — центральная зона. Оси считаются отдельно:
 *  - отряд в центральной зоне — по этой оси кадр не двигается;
 *  - отряд за ней — кадр сдвигается ровно настолько, чтобы все ячейки действий
 *    отряда (перемещения, цели) вместе с его ячейкой оказались в зоне;
 *  - ячейки в зону не помещаются (сильное приближение) — отряд встает в центр.
 *
 * Все величины — в единицах мира.
 * @param {Object} params
 * @param {{x: number, y: number}} params.center — текущий центр свободной области
 * @param {{width: number, height: number}} params.frame — размер свободной области
 * @param {{x: number, y: number}} params.unitPoint — центр ячейки отряда
 * @param {{minX: number, maxX: number, minY: number, maxY: number}} params.cellsBounds —
 *   рамка ячеек действий вместе с ячейкой отряда
 * @returns {{x: number, y: number}}
 */
export const getAutoSelectionFrameCenter = ({center, frame, unitPoint, cellsBounds}) => {
  const fitAxis = (current, frameSize, unit, cellsMin, cellsMax) => {
    const halfZone = (frameSize * AUTO_SELECTION_CAMERA_CENTRAL_ZONE_FRACTION) / 2;
    if (Math.abs(unit - current) <= halfZone) {
      return current;
    }
    if (cellsMax - cellsMin > halfZone * 2) {
      return unit;
    }
    // Ближайший к текущему центр, при котором рамка ячеек целиком в зоне
    return Math.min(Math.max(current, cellsMax - halfZone), cellsMin + halfZone);
  };
  return {
    x: fitAxis(center.x, frame.width, unitPoint.x, cellsBounds.minX, cellsBounds.maxX),
    y: fitAxis(center.y, frame.height, unitPoint.y, cellsBounds.minY, cellsBounds.maxY),
  };
};
